var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warningIcon",on:{"click":_vm.clickIcon}},[(_vm.warningIcon)?_c('img',{attrs:{"src":require("./static/anIcon.png"),"alt":""}}):_c('img',{attrs:{"src":require("./static/liangIcom.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }